import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import scrollToComponent from 'react-scroll-to-component';
import { Redirect } from 'react-router-dom';

import EventOnlineView from '../components/content/event/EventOnlineView';
import Faq from '../components/content/Faq';
import InsufficientResultsInformation from '../components/content/informations/InsufficientResultsInformation';
import SuggestionsMediaList from '../components/content/lists/SuggestionsMediaList';

class EventSmartSearchPage extends Component {
  constructor(props) {
    super(props);

    const { participant } = props.viewer.event;
    const count = participant ? participant.suggestions.mediaInfo.count : 0;

    this.state = {
      extendedSearchSelectedTab: count === 0 ? 1 : 0,
      extendedSearchExpand: count !== 0,
    };
  }

  handleExtendedSearchTabChanged = (event, value) => {
    this.setState({
      extendedSearchSelectedTab: value,
      extendedSearchExpand: true,
    });
  };

  handleExtendedSearchExpand = () => {
    this.setState(prevState => {
      const {
        extendedSearchExpand: prevExpand,
        extendedSearchSelectedTab: prevSelectedTab,
      } = prevState;

      return {
        extendedSearchExpand: !prevExpand,
        // if the extended search changes from open to close it is important to reset
        // the selected tab to its default. Otherwise the media list will not be rendered.
        extendedSearchSelectedTab: prevExpand ? 0 : prevSelectedTab,
      };
    });
  };

  scrollToEventOnlineView(tabIndex) {
    scrollToComponent(this.eventOnlineView);
    this.setState({
      extendedSearchExpand: true,
      extendedSearchSelectedTab: tabIndex,
    });
  }

  render() {
    const { customerKey, viewer, snFromUrl } = this.props;
    const { event } = viewer;

    if (event.state === 'reminder') {
      return <Redirect to={`/event/${event.sgId}`} />;
    }

    const { extendedSearchSelectedTab, extendedSearchExpand } = this.state;

    const participantMediaCount = event.participant
      ? event.participant.media.mediaInfo.count
      : 0;

    if (!event.smartSearch) {
      return <Redirect to={`/event/${event.sgId}`} />;
    }

    return (
      <div className="container-960 container-page">
        <EventOnlineView
          customerKey={customerKey}
          ref={view => (this.eventOnlineView = view)}
          onlineEvent={event}
          urlSn={snFromUrl}
          extendedSearchSelectedTab={extendedSearchSelectedTab}
          extendedSearchExpand={extendedSearchExpand}
          hasSmartSearchTab={event.smartSearch && participantMediaCount !== 0}
          hasGpsSearchTab={event.gps}
          hasFaceSearchTab={event.searchByFaceAsFeature && (!event.searchByFace || participantMediaCount !== 0)}
          onExtendedSearchTabChange={this.handleExtendedSearchTabChanged}
          onExtendedSearchExpand={this.handleExtendedSearchExpand}
        />
        <hr className="col-xs-16 col-sm-12" />
        {extendedSearchSelectedTab === 0 &&
          participantMediaCount !== 0 && (
            <SuggestionsMediaList
              customerKey={customerKey}
              eventHasSearchByFace={event.searchByFace ? true : false}
              eventHasSecondFactor={event.secondFactorType ? true : false}
              eventId={event.sgId}
              startnumber={event.participant.startnumber}
              suggestionsMedia={event.participant.suggestions}
              offer={event}
              participantMediaCount={participantMediaCount}
            />
          )}
          {!extendedSearchExpand && participantMediaCount === 0 && (
            <InsufficientResultsInformation
              count={participantMediaCount}
              raceResultsUrl={event.hostResultUrl}
              showGpsSearchLink={event.gps}
              showSmartSearchLink={event.smartSearch}
              tagWithStartNumber={!event.searchByFace}
              onDeepSearchClick={() => this.scrollToEventOnlineView(0)}
              onCategorySearchClick={() => this.scrollToEventOnlineView(1)}
              onGpsSearchClick={() => this.scrollToEventOnlineView(2)}
            />
          )}
        <Faq onFindMore={() => this.scrollToEventOnlineView(0)} />
      </div>
    );
  }
}

EventSmartSearchPage.propTypes = {
  customerKey: PropTypes.string,
  snFromUrl: PropTypes.string,
  viewer: PropTypes.object,
};

export { EventSmartSearchPage };

export default createFragmentContainer(EventSmartSearchPage, {
  viewer: graphql`
    fragment EventSmartSearchPage_viewer on Viewer {
      event(id: $eventId) {
        id
        sgId
        gps
        hostResultUrl

        participant(startnumber: $startnumber, secondFactor: $secondFactor) {
          media {
            mediaInfo {
              count
            }
          }
          suggestions {
            mediaInfo {
              count
            }
            ...SuggestionsMediaList_suggestionsMedia
          }
          startnumber
        }
        secondFactorType {
          type
        }
        searchByFace
        searchByFaceAsFeature
        smartSearch
        state
        ...EventOnlineView_onlineEvent
        ...SuggestionsMediaList_offer
      }
    }
  `,
});
